<div class="obg-m-betting-limit-change">
	<div class="obg-m-betting-limit-change-header">
		<img obgImageContent="general.warning" />
		<h1>{{ "betting-limit.change-betting-limit" | translate }}</h1>
	</div>
	<div class="obg-m-betting-limit-change-content">
		<div
			*ngIf="!isBiggerLimit"
			[innerHtml]="'betting-limit.change-betting-limit-header.restrict' | translate"
		></div>
		<div *ngIf="isBiggerLimit" [innerHtml]="'betting-limit.change-betting-limit-header.loosen' | translate"></div>
		<div class="obg-m-betting-limit-change-limits">
			<div>
				<b>{{ "betting-limit.change-betting-limit.from" | translate }}</b>
			</div>
			<div
				*ngIf="currentLimit"
				class="obg-m-betting-limit-change-display"
				[innerHtml]="
					'betting-limit.change-betting-limit.display'
						| translate
							: {
									limit:
										'betting-limit.cash-per-period.' + (currentLimit.limitPeriod | lowercase)
										| translate: { amount: currentLimit.limitValue | obgCurrency },
							  }
				"
				test-id="current-limit"
				data-test-id="current-limit"
			></div>
			<div *ngIf="!currentLimit" class="obg-m-betting-limit-change-display">
				<b>{{ "betting-limit.limit-none" | translate }}</b>
			</div>
			<div>
				<b>{{ "betting-limit.change-betting-limit.to" | translate }}</b>
			</div>
			<div
				*ngIf="nextLimit"
				class="obg-m-betting-limit-change-display"
				[innerHtml]="
					'betting-limit.change-betting-limit.display'
						| translate
							: {
									limit:
										'betting-limit.cash-per-period.' + (nextLimit.period | lowercase)
										| translate: { amount: nextLimit.limitValue | obgCurrency },
							  }
				"
				test-id="current-limit"
				data-test-id="current-limit"
			></div>
			<div *ngIf="!nextLimit" class="obg-m-betting-limit-change-display">
				<b>{{ "betting-limit.limit-none" | translate }}</b>
			</div>
		</div>
		<div
			*ngIf="!isBiggerLimit"
			[innerHtml]="'betting-limit.change-betting-limit-footer.restrict' | translate"
		></div>
		<div *ngIf="isBiggerLimit" [innerHtml]="'betting-limit.change-betting-limit-footer.loosen' | translate"></div>
	</div>
</div>
